
class UtilsService {
  window = window as any;

  getRandomArbitrary(min: number, max: number) {
    return Math.round(Math.random() * (max - min) + min);
  }

  numberWithCommas(x: number) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  getQueryString(name: string) {
    const reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)');
    const r = window.location.search.substr(1).match(reg);
    if (r != null) {
      return decodeURIComponent(r[2]);
    }
    return '';
  }

  sortChinese(arr: string[]) {
    return arr.sort((item1, item2) => {
      return item1.localeCompare(item2, 'zh-CN');
    });
  }

  sendEvent(type: 't' | 'm') {
    if (type === 't') this.window.ga('send', 'event', 'nav', 'share', 'timeline');
    else this.window.ga('send', 'event', 'nav', 'share', 'message');
  }

  gaEvent(eventName: string, category: string, label: string) {
    if (this.window.gtag) {
      this.window.gtag('event', eventName, { event_category: category, event_label: label });
    }
  }

  /**
   * 声音
   * @param {String} url	链接
   * @param {Boolean} autoPlay	自动播放
   * @param {Boolean} loop	循环
   * @param {Function} onPlay	当播放时
   * @param {Function} onPause	当暂停时
   * @param {Function} onEnded	当结束时
   *
   *
   */
  lAudio(url: string, autoPlay: boolean, loop: boolean, onPlay: any, onPause: any, onEnded: any) {
    const audio = document.createElement('audio');
    audio.src = url;
    audio.loop = false;

    audio.autoplay = autoPlay;
    if (audio.autoplay) {
      document.addEventListener('WeixinJSBridgeReady', function() {
        audio.play();
      });
    }
    if (onPlay) audio.addEventListener('play', onPlay);
    if (onPause) audio.addEventListener('pause', onPause);
    audio.addEventListener('ended', () => {
      if (onEnded) onEnded();

      if (loop) {
        audio.play();
      }
    });

    // audio.restart = function () {
    //   audio.currentTime = 0;
    //   audio.play();
    // }

    // audio.originalPlay = audio.play

    // audio.play = function () {
    //   $(audio).unbind("play", loadPlay)
    //   audio.originalPlay()
    // }

    // //调用play来实现加载
    // audio.startLoad = function () {
    //   $(audio).bind("play", loadPlay)
    //   audio.originalPlay()

    // }
    // function loadPlay() {
    //   audio.pause()
    // }

    return audio;
  }

  // assets 预加载
  reloadAssets(imgs: any[]) {
    // css3 img preload, work with gfp.js by nodejs
    const createCss = () => {
      let backgroundCss = '';
      for (let i = 0; i < imgs.length; i++) {
        let u = imgs[i];
        let url = 'url(' + u + ') no-repeat 0 0 / 0';
        if (i + 1 == imgs.length) url += ';\n';
        else url += ',\n';
        backgroundCss += url;
        // console.log(backgroundCss);
      }
      let result = 'background:\n' + backgroundCss;
      return result;
    };
    // console.log(css());

    let head = document.head || document.getElementsByTagName('head')[0];
    let style = document.createElement('style');
    let css = `.preload-images { ${createCss()} }`;

    head.appendChild(style);

    style.type = 'text/css';
    style.appendChild(document.createTextNode(css));
  }

  // base64 to file
  async urltoFile(url: string, filename: string, mimeType: string) {
    mimeType = mimeType || (url.match(/^data:([^;]+);/) || '')[1];
    const res = await fetch(url);
    const buf = await res.arrayBuffer();
    return new File([buf], filename, { type: mimeType });
  }

  // load a script
  loadScriptAsync(url: string, doneCallback: Function) {
    let tag = document.createElement('script');
    tag.onload = function() {
      doneCallback();
    };
    tag.onerror = function() {
      throw new Error('failed to load ' + url);
    };
    tag.async = true;
    tag.src = url;
    document.head.appendChild(tag);
  }

  removeJSFile(filename: string) {
    let tags: any = document.getElementsByTagName('script');
    for (let i = tags.length; i >= 0; i--) {
      //search backwards within nodelist for matching elements to remove
      if (tags[i] && tags[i].getAttribute('src') != null && tags[i].getAttribute('src').indexOf(filename) != -1) tags[i].parentNode.removeChild(tags[i]); //remove element by calling parentNode.removeChild()
    }
  }

  /** 毫秒转时间格式 */
  microTimeFormat(time: number) {
    let timeString =
      (Math.floor(time / 60000) > 9 ? Math.floor(time / 60000) : '0' + Math.floor(time / 60000)) +
      ':' +
      (Math.floor(time / 1000) % 60 > 9 ? Math.floor(time / 1000) % 60 : '0' + (Math.floor(time / 1000) % 60)) +
      ':' +
      (Math.floor(time / 10) % 100 > 9 ? Math.floor(time / 10) % 100 : '0' + (Math.floor(time / 10) % 100));
    return timeString;
  }

  /** 毫秒转文字格式 */
  ms2Str(time: number, type: 'zh' | 'en' = 'en') {
    const divider = type === 'zh' ? ['分', '秒'] : ["'", '"'];
    let timeString =
      (Math.floor(time / 60000) > 9 ? Math.floor(time / 60000) : '0' + Math.floor(time / 60000)) +
      divider[0] +
      (Math.floor(time / 1000) % 60 > 9 ? Math.floor(time / 1000) % 60 : '0' + (Math.floor(time / 1000) % 60)) +
      divider[1] +
      (Math.floor(time / 10) % 100 > 9 ? Math.floor(time / 10) % 100 : '0' + (Math.floor(time / 10) % 100));
    return timeString;
  }
  /**
   * 获取倒计时  天
   * @param end 结束时间
   * @param now 开始时间
   */
  getDays(end: number, now: number) {
    var differTime = end - now;
    let d = 0;
    if (differTime >= 0) {
      d = Math.floor(differTime / 1000 / 60 / 60 / 24);
    }
    console.log('-------------------', d);

    return d;
  }
  /**
   * 获取倒计时 时分秒
   * @param end 结束时间
   * @param now 开始时间
   */
  countTime(end: number, now: number) {
    var differTime = end - now;
    let countdown = '00:00:00';
    var h, m, s;
    if (differTime >= 0) {
      h = Math.floor(differTime / 1000 / 60 / 60);
      m = Math.floor((differTime / 1000 / 60) % 60);
      s = Math.floor((differTime / 1000) % 60);
      h = h < 10 ? '0' + h : h;
      m = m < 10 ? '0' + m : m;
      s = s < 10 ? '0' + s : s;
      countdown = h + ':' + m + ':' + s;
    }
    return countdown;
  }
  // 参数名ASCII码从小到大排序（字典序）-微信SDK常用到（参数列表加密前排序）
  raw(args: any) {
    let keys = Object.keys(args);
    keys = keys.sort();
    const newArgs: any = {};
    keys.forEach(function(key) {
      newArgs[key] = args[key];
    });

    let string = '';
    for (const k in newArgs) {
      if (!newArgs.hasOwnProperty(k)) continue;
      string += '&' + k + '=' + newArgs[k];
    }
    string = string.substr(1);
    return string;
  }
}

export const utilsService = new UtilsService();
